module.exports = __webpack_public_path__ + "static/media/logo.a4b14063.png";